import { AppDispatch, RootState } from '../index';
import { FetchState } from '../fetchState';
import { baseSlice, BaseType, getItem } from '../baseHelper';
import { UserDto } from '@api/models/user/UserDto';
import { UserState } from '@api/models/enums/UserState';
import { userService } from '@api/services/services';

type State = BaseType<UserDto>;

const initialState: State = {
  state: FetchState.None,
  data: {
    id: '',
    name: '',
    lastName: '',
    email: '',
    phone: '',
    state: UserState.Invited,
    language: 'cs',
    roles: [],
    establishments: [],
  },
};

export const userSlice = baseSlice({
  name: 'user',
  initialState,
});

export const selectUserState = (state: RootState) => state.user.state;
export const selectUser = (state: RootState) => state.user.data;
export const userActions = userSlice.actions;

export const getUser = (userId: string) => (dispatch: AppDispatch) => {
  const handleGetData = () => {
    return userService.getById(userId);
  };

  getItem({
    dispatch,
    actions: userActions,
    getData: handleGetData,
  });
};
